import MyTinySlider from './MyTinySlider';
import { onDomReady } from '../../components/dynamic/observer';

onDomReady(() => {
  // Инициализируем все слайдеры на странице (если их несколько)
  const switchableSliders = document.querySelectorAll('[data-switchable-slider-container]');
  if (!switchableSliders.length) {
    return;
  }

  switchableSliders.forEach((sliderContainer) => {
    // Ищем элементы слайдера внутри контейнера, чтобы избежать конфликтов при нескольких слайдерах
    const sliderList = sliderContainer.querySelector('[data-switchable-slider]');
    if (!sliderList) {
      return;
    }

    // Инициализируем слайдер для каждого контейнера
    const switchableSlider = new MyTinySlider({
      sliderContainer,
      sliderList: '[data-switchable-slider]',
      arrowLeft: '[data-switchable-left]',
      arrowRight: '[data-switchable-right]',
      slideIndex: '[data-switchable-slider-index]',
      slideCount: '[data-switchable-count]',
      slideBy: 1,
      items: 1,
      nav: true,
      navPosition: 'bottom',
      speed: 1300,
      mode: 'gallery',
      animateIn: 'animate_in',
      animateOut: 'animate_out',
      animateNormal: 'normal',
      center: false,
      controls: false,
      rewind: true,
      loop: false,
      preventActionWhenRunning: true,
    });
  });
});